'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactImmutableProptypes = require('react-immutable-proptypes');

var _reactImmutableProptypes2 = _interopRequireDefault(_reactImmutableProptypes);

var _baseBcReactComponent = require('@bibliocommons/base-bc-react-component');

var _baseBcReactComponent2 = _interopRequireDefault(_baseBcReactComponent);

var _baseButtons = require('@bibliocommons/base-buttons');

var _loginForm = require('../../login-form');

var _loginForm2 = _interopRequireDefault(_loginForm);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var propTypes = {
  auth: _reactImmutableProptypes2.default.mapContains({
    userInfo: _reactImmutableProptypes2.default.map
  })
};

var Login = function (_BcReactComponent) {
  _inherits(Login, _BcReactComponent);

  function Login() {
    _classCallCheck(this, Login);

    return _possibleConstructorReturn(this, (Login.__proto__ || Object.getPrototypeOf(Login)).apply(this, arguments));
  }

  _createClass(Login, [{
    key: 'render',
    value: function render() {
      var userInfo = this.props.auth.get('userInfo');
      return _react2.default.createElement(
        'div',
        null,
        userInfo ? Login.renderLoggedIn(this.props.authActions, userInfo) : Login.renderNotLoggedIn(this.props.authActions)
      );
    }
  }], [{
    key: 'renderNotLoggedIn',
    value: function renderNotLoggedIn(authActions) {
      return _react2.default.createElement(_loginForm2.default, { login: authActions.login });
    }
  }, {
    key: 'renderLoggedIn',
    value: function renderLoggedIn(authActions, userInfo) {
      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          'h1',
          null,
          userInfo.get('username')
        ),
        _react2.default.createElement(
          _baseButtons.TextButton,
          { handleClick: authActions.logout },
          'Log Out'
        )
      );
    }
  }]);

  return Login;
}(_baseBcReactComponent2.default);

Login.propTypes = propTypes;

exports.default = Login;


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/login/lib/components/login/components/Login.component.js
// module id = 1429
// module chunks = 1